import { useState } from "react";
import { Sparkles } from "lucide-react";
import markUrl from "@/assets/assistant-mark.png";
import { cn } from "@/lib/utils";

const SIZE = {
  xs: "h-3.5 w-3.5 [&>svg]:h-2.5 [&>svg]:w-2.5",
  sm: "h-7 w-7 [&>svg]:h-3.5 [&>svg]:w-3.5",
  md: "h-10 w-10 [&>svg]:h-5 [&>svg]:w-5",
  lg: "h-16 w-16 [&>svg]:h-7 [&>svg]:w-7",
} as const;

/**
 * The assistant's face: the Tax Free Wealth Plan bird, on a white disc like
 * the app icon. Never a person's photo. `white` is the one-color version for
 * blue backgrounds (a message bubble).
 *
 * The image is bundled with the app (a hashed file next to the scripts), so
 * every build that ships this component ships the bird. If it still fails to
 * load, a drawn mark takes its place rather than a broken-image box.
 */
export function AssistantMark({ size = "md", tone = "color", className }: { size?: keyof typeof SIZE; tone?: "color" | "white"; className?: string }) {
  const [failed, setFailed] = useState(false);
  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-full",
        failed ? (tone === "color" ? "bg-tint text-white" : "text-white") : tone === "color" && "bg-white shadow-card",
        SIZE[size],
        className,
      )}
    >
      {failed ? (
        <Sparkles strokeWidth={2.2} />
      ) : (
        <img
          src={markUrl}
          alt=""
          draggable={false}
          onError={() => setFailed(true)}
          className={cn("h-full w-full select-none", tone === "white" && "brightness-0 invert")}
        />
      )}
    </span>
  );
}
